import type { CandidateProfile, EmployerProfile, RecruiterProfile, User } from '../types/core';

/**
 * Demonstration accounts. `demoPassword` exists ONLY because this build has no
 * server: sign-in is simulated. In production, credentials are never stored in
 * or shipped to the client, and passwords are hashed server-side.
 */
export const users: User[] = [
  {
    id: 'user-cand-1',
    email: 'candidate@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Marion T. Whitfield',
    preferredName: 'Marion',
    emailVerifiedAt: '2026-06-02T10:14:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-09-01T08:22:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-06-02T09:40:00Z',
    updatedAt: '2026-08-30T17:05:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-cand-2',
    email: 'candidate.new@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Devon R. Achebe',
    preferredName: 'Devon',
    emailVerifiedAt: '2026-08-28T12:00:00Z',
    mfaEnabled: false,
    lastSignInAt: '2026-08-31T19:10:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-08-28T11:44:00Z',
    updatedAt: '2026-08-31T19:10:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-cand-3',
    email: 'candidate.board@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Priya N. Raghunathan',
    preferredName: 'Priya',
    emailVerifiedAt: '2026-05-19T14:30:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-08-29T07:55:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-05-19T14:02:00Z',
    updatedAt: '2026-08-29T07:55:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-cand-4',
    email: 'candidate.tech@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Anders J. Lindqvist',
    preferredName: 'Anders',
    emailVerifiedAt: '2026-07-08T09:00:00Z',
    mfaEnabled: false,
    lastSignInAt: '2026-08-30T21:40:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-07-08T08:31:00Z',
    updatedAt: '2026-08-30T21:40:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-cand-5',
    email: 'candidate.security@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Rosalind K. Ferreira',
    preferredName: 'Rosalind',
    emailVerifiedAt: '2026-04-11T16:20:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-08-27T13:12:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-04-11T15:58:00Z',
    updatedAt: '2026-08-27T13:12:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-cand-6',
    email: 'candidate.energy@velnoris.demo',
    role: 'candidate',
    status: 'active',
    fullLegalName: 'Thomas O. Baptiste',
    preferredName: 'Tom',
    emailVerifiedAt: '2026-03-27T11:11:00Z',
    mfaEnabled: false,
    lastSignInAt: '2026-08-24T10:02:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-03-27T10:48:00Z',
    updatedAt: '2026-08-24T10:02:00Z',
    demoPassword: 'Executive#2026',
  },
  {
    id: 'user-emp-1',
    email: 'employer@velnoris.demo',
    role: 'employer',
    status: 'active',
    fullLegalName: 'Helena M. Osei',
    preferredName: 'Helena',
    emailVerifiedAt: '2026-07-21T09:30:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-09-01T07:40:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-07-21T09:02:00Z',
    updatedAt: '2026-08-31T16:00:00Z',
    demoPassword: 'Employer#2026',
  },
  {
    id: 'user-emp-2',
    email: 'employer.pending@velnoris.demo',
    role: 'employer',
    status: 'pending_verification',
    fullLegalName: 'Gregory S. Almeida',
    preferredName: 'Greg',
    emailVerifiedAt: '2026-08-30T15:10:00Z',
    mfaEnabled: false,
    lastSignInAt: '2026-08-31T08:05:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-08-30T14:52:00Z',
    updatedAt: '2026-08-31T08:05:00Z',
    demoPassword: 'Employer#2026',
  },
  {
    id: 'user-rec-1',
    email: 'recruiter@velnoris.demo',
    role: 'recruiter',
    status: 'active',
    fullLegalName: 'Claudia B. Nwosu',
    preferredName: 'Claudia',
    emailVerifiedAt: '2026-01-08T08:00:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-09-01T07:05:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-01-08T08:00:00Z',
    updatedAt: '2026-09-01T07:05:00Z',
    demoPassword: 'Consultant#2026',
  },
  {
    id: 'user-rec-2',
    email: 'recruiter.tech@velnoris.demo',
    role: 'recruiter',
    status: 'active',
    fullLegalName: 'Idris F. Kaplan',
    preferredName: 'Idris',
    emailVerifiedAt: '2026-01-08T08:00:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-08-31T18:20:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-01-08T08:00:00Z',
    updatedAt: '2026-08-31T18:20:00Z',
    demoPassword: 'Consultant#2026',
  },
  {
    id: 'user-rec-3',
    email: 'recruiter.energy@velnoris.demo',
    role: 'recruiter',
    status: 'active',
    fullLegalName: 'Saoirse M. Dunne',
    preferredName: 'Saoirse',
    emailVerifiedAt: '2026-02-14T08:00:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-08-30T09:15:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-02-14T08:00:00Z',
    updatedAt: '2026-08-30T09:15:00Z',
    demoPassword: 'Consultant#2026',
  },
  {
    id: 'user-admin-1',
    email: 'admin@velnoris.demo',
    role: 'administrator',
    status: 'active',
    fullLegalName: 'Adaeze P. Iwu',
    preferredName: 'Ada',
    emailVerifiedAt: '2026-01-02T08:00:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-09-01T06:50:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-01-02T08:00:00Z',
    updatedAt: '2026-09-01T06:50:00Z',
    demoPassword: 'Administrator#2026',
  },
  {
    id: 'user-super-1',
    email: 'superadmin@velnoris.demo',
    role: 'super_administrator',
    status: 'active',
    fullLegalName: 'Ruth E. Castellanos',
    preferredName: 'Ruth',
    emailVerifiedAt: '2026-01-01T08:00:00Z',
    mfaEnabled: true,
    lastSignInAt: '2026-08-31T22:00:00Z',
    failedSignInAttempts: 0,
    createdAt: '2026-01-01T08:00:00Z',
    updatedAt: '2026-08-31T22:00:00Z',
    demoPassword: 'SuperAdmin#2026',
  },
];

export const candidateProfiles: CandidateProfile[] = [
  {
    id: 'cand-1',
    userId: 'user-cand-1',
    preferredName: 'Marion',
    professionalEmail: 'candidate@velnoris.demo',
    telephone: '+1 (615) 555-0142',
    city: 'Nashville',
    state: 'TN',
    country: 'United States',
    linkedInUrl: 'https://www.linkedin.com/in/example-profile',
    currentTitle: 'Chief Operating Officer, Regional Division',
    currentEmployer: 'Confidential — not disclosed by candidate',
    employerDisclosed: false,
    industries: ['Healthcare and Health Technology'],
    functionalExpertise: ['Operations', 'General Management'],
    yearsLeadershipExperience: 18,
    currentSeniority: 'c_suite',
    targetPositions: ['Chief Operating Officer', 'Health System President', 'Chief Executive Officer'],
    preferredIndustries: ['Healthcare and Health Technology'],
    preferredLocations: ['Nashville, TN', 'Atlanta, GA', 'Charlotte, NC'],
    workArrangementPreference: ['onsite', 'hybrid'],
    employmentTypePreference: ['permanent'],
    compensationExpectation: { currency: 'USD', baseMin: 600000, baseMax: 780000, bonusTargetPct: 45, isEstimate: false },
    workAuthorization: 'us_citizen_or_permanent_resident',
    relocationPreference: 'will_relocate_for_right_role',
    travelAvailability: 'up_to_50',
    earliestAvailability: '2026-11-01',
    executiveSummary:
      'Operating executive with eighteen years in provider organizations, most recently accountable for the operating performance of a four-hospital division following two acquisitions. Delivered standardization of clinical support processes across acquired sites without a measurable decline in quality indicators, and rebuilt the relationship between administrative leadership and an independent physician group.',
    education: ['MHA, health administration', 'BSc, biological sciences'],
    licences: [],
    skills: [
      'Multi-site operating leadership',
      'Post-acquisition integration',
      'Clinical-administrative partnership',
      'Capacity and throughput management',
      'Board reporting',
      'Ambulatory network development',
    ],
    leadershipScope: { teamSize: 3200, budgetUsd: 640000000, pAndLOwnership: true, boardExposure: true },
    referralSource: 'Referred by a former colleague',
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: true,
      careerServices: false,
    },
    profileStatus: 'active_in_network',
    createdAt: '2026-06-02T09:40:00Z',
    updatedAt: '2026-08-30T17:05:00Z',
  },
  {
    id: 'cand-2',
    userId: 'user-cand-2',
    preferredName: 'Devon',
    professionalEmail: 'candidate.new@velnoris.demo',
    city: 'Chicago',
    state: 'IL',
    country: 'United States',
    currentTitle: 'Senior Vice President, Finance',
    employerDisclosed: false,
    industries: ['Manufacturing and Industrial'],
    functionalExpertise: ['Finance'],
    currentSeniority: 'svp',
    targetPositions: ['Chief Financial Officer'],
    preferredIndustries: ['Manufacturing and Industrial'],
    preferredLocations: ['Chicago, IL'],
    workArrangementPreference: ['hybrid'],
    employmentTypePreference: ['permanent'],
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: false,
      careerServices: false,
    },
    profileStatus: 'incomplete',
    createdAt: '2026-08-28T11:44:00Z',
    updatedAt: '2026-08-31T19:10:00Z',
  },
  {
    id: 'cand-3',
    userId: 'user-cand-3',
    preferredName: 'Priya',
    professionalEmail: 'candidate.board@velnoris.demo',
    telephone: '+1 (617) 555-0198',
    city: 'Boston',
    state: 'MA',
    country: 'United States',
    currentTitle: 'Non-Executive Director and former Chief Financial Officer',
    employerDisclosed: true,
    currentEmployer: 'Independent portfolio of directorships',
    industries: ['Technology, Data and Artificial Intelligence', 'Financial Services'],
    functionalExpertise: ['Finance', 'Board and Governance'],
    yearsLeadershipExperience: 24,
    currentSeniority: 'board_director',
    targetPositions: ['Non-Executive Director', 'Audit Committee Chair'],
    preferredIndustries: ['Technology, Data and Artificial Intelligence'],
    preferredLocations: ['Boston, MA', 'New York, NY'],
    workArrangementPreference: ['hybrid', 'remote'],
    employmentTypePreference: ['board_appointment', 'fractional'],
    compensationExpectation: { currency: 'USD', baseMin: 85000, baseMax: 140000, isEstimate: false },
    workAuthorization: 'us_citizen_or_permanent_resident',
    relocationPreference: 'no_relocation',
    travelAvailability: 'up_to_25',
    earliestAvailability: '2026-09-15',
    executiveSummary:
      'Former Chief Financial Officer of a listed technology business, now holding two non-executive directorships. Chaired an audit committee through a listing process and a subsequent restatement remediation. Audit committee financial expert under listed-company standards.',
    education: ['MBA', 'BA, economics'],
    licences: ['Certified Public Accountant'],
    skills: [
      'Audit committee chairmanship',
      'Financial reporting oversight',
      'Internal control and audit readiness',
      'Public-market readiness',
      'Independent governance judgement',
    ],
    leadershipScope: { pAndLOwnership: false, boardExposure: true },
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: true,
      careerServices: true,
    },
    profileStatus: 'active_in_network',
    createdAt: '2026-05-19T14:02:00Z',
    updatedAt: '2026-08-29T07:55:00Z',
  },
  {
    id: 'cand-4',
    userId: 'user-cand-4',
    preferredName: 'Anders',
    professionalEmail: 'candidate.tech@velnoris.demo',
    telephone: '+1 (512) 555-0177',
    city: 'Austin',
    state: 'TX',
    country: 'United States',
    currentTitle: 'Senior Vice President, Engineering',
    employerDisclosed: false,
    industries: ['Technology, Data and Artificial Intelligence'],
    functionalExpertise: ['Technology', 'Product'],
    yearsLeadershipExperience: 15,
    currentSeniority: 'svp',
    targetPositions: ['Chief Technology Officer'],
    preferredIndustries: ['Technology, Data and Artificial Intelligence'],
    preferredLocations: ['Austin, TX', 'Denver, CO'],
    workArrangementPreference: ['hybrid', 'remote'],
    employmentTypePreference: ['permanent'],
    compensationExpectation: { currency: 'USD', baseMin: 470000, baseMax: 600000, bonusTargetPct: 40, isEstimate: false },
    workAuthorization: 'authorized_no_sponsorship_required',
    relocationPreference: 'will_relocate_for_right_role',
    travelAvailability: 'up_to_25',
    earliestAvailability: '2026-10-01',
    executiveSummary:
      'Engineering leader who consolidated four acquired products into a single platform across three sites while holding delivery commitments, and reduced infrastructure cost per transaction by a measured margin over eighteen months. Built the engineering leadership layer that removed three single-person dependencies.',
    education: ['MSc, computer science'],
    skills: [
      'Platform architecture consolidation',
      'Engineering organization leadership',
      'Applied machine learning delivery',
      'Cost and infrastructure efficiency',
      'Post-acquisition integration',
    ],
    leadershipScope: { teamSize: 310, budgetUsd: 42000000, pAndLOwnership: false, boardExposure: true },
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: true,
      careerServices: false,
    },
    profileStatus: 'active_in_network',
    createdAt: '2026-07-08T08:31:00Z',
    updatedAt: '2026-08-30T21:40:00Z',
  },
  {
    id: 'cand-5',
    userId: 'user-cand-5',
    preferredName: 'Rosalind',
    professionalEmail: 'candidate.security@velnoris.demo',
    telephone: '+1 (212) 555-0164',
    city: 'New York',
    state: 'NY',
    country: 'United States',
    currentTitle: 'Deputy Chief Information Security Officer',
    employerDisclosed: false,
    industries: ['Financial Services', 'Cybersecurity'],
    functionalExpertise: ['Information Security', 'Risk'],
    yearsLeadershipExperience: 13,
    currentSeniority: 'vice_president',
    targetPositions: ['Chief Information Security Officer'],
    preferredIndustries: ['Financial Services', 'Cybersecurity'],
    preferredLocations: ['New York, NY'],
    workArrangementPreference: ['hybrid'],
    employmentTypePreference: ['permanent'],
    compensationExpectation: { currency: 'USD', baseMin: 430000, baseMax: 520000, bonusTargetPct: 55, isEstimate: false },
    workAuthorization: 'us_citizen_or_permanent_resident',
    relocationPreference: 'no_relocation',
    travelAvailability: 'up_to_25',
    earliestAvailability: '2026-12-01',
    executiveSummary:
      'Security leader in a regulated institution, accountable for the resilience programme and the regulator relationship on operational resilience. Led the institution’s response to a material third-party incident and the subsequent regulatory engagement.',
    education: ['BSc, information systems'],
    skills: [
      'Security strategy and risk quantification',
      'Regulatory engagement',
      'Incident response leadership',
      'Third-party risk',
    ],
    leadershipScope: { teamSize: 95, budgetUsd: 28000000, pAndLOwnership: false, boardExposure: true },
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: false,
      careerServices: false,
    },
    profileStatus: 'active_in_network',
    createdAt: '2026-04-11T15:58:00Z',
    updatedAt: '2026-08-27T13:12:00Z',
  },
  {
    id: 'cand-6',
    userId: 'user-cand-6',
    preferredName: 'Tom',
    professionalEmail: 'candidate.energy@velnoris.demo',
    city: 'Denver',
    state: 'CO',
    country: 'United States',
    currentTitle: 'Senior Vice President, Development',
    employerDisclosed: false,
    industries: ['Energy and Infrastructure'],
    functionalExpertise: ['General Management', 'Operations'],
    yearsLeadershipExperience: 20,
    currentSeniority: 'svp',
    targetPositions: ['Chief Development Officer', 'Chief Operating Officer'],
    preferredIndustries: ['Energy and Infrastructure'],
    preferredLocations: ['Denver, CO', 'Houston, TX'],
    workArrangementPreference: ['hybrid'],
    employmentTypePreference: ['permanent'],
    compensationExpectation: { currency: 'USD', baseMin: 440000, baseMax: 560000, bonusTargetPct: 45, isEstimate: false },
    workAuthorization: 'us_citizen_or_permanent_resident',
    relocationPreference: 'will_relocate_for_right_role',
    travelAvailability: 'over_50',
    earliestAvailability: '2026-10-15',
    executiveSummary:
      'Development executive who has taken utility-scale solar and storage projects to notice to proceed across three ISO markets, with accountability for interconnection strategy and permitting.',
    education: ['MBA', 'BEng, civil engineering'],
    skills: [
      'Utility-scale project development',
      'Interconnection and transmission',
      'Permitting and land',
      'Offtake negotiation',
    ],
    leadershipScope: { teamSize: 48, budgetUsd: 30000000, pAndLOwnership: true, boardExposure: false },
    communicationPreferences: {
      opportunityMatches: true,
      applicationUpdates: true,
      marketInsights: true,
      careerServices: false,
    },
    profileStatus: 'active_in_network',
    createdAt: '2026-03-27T10:48:00Z',
    updatedAt: '2026-08-24T10:02:00Z',
  },
];

export const employerProfiles: EmployerProfile[] = [
  {
    id: 'emp-1',
    userId: 'user-emp-1',
    organizationName: '[Verified client organization name]',
    website: 'https://[client-domain].com',
    contactName: 'Helena M. Osei',
    corporateEmail: 'employer@velnoris.demo',
    industry: 'Healthcare and Health Technology',
    headquartersLocation: 'Nashville, TN',
    organizationType: 'private',
    verificationStatus: 'verified',
    verificationNotes:
      'Domain ownership confirmed; contact verified against organization directory; engagement letter signed by named officer.',
    verifiedByUserId: 'user-admin-1',
    verifiedAt: '2026-07-24T11:00:00Z',
    assignedConsultantId: 'rec-1',
    createdAt: '2026-07-21T09:02:00Z',
    updatedAt: '2026-08-31T16:00:00Z',
  },
  {
    id: 'emp-2',
    userId: 'user-emp-2',
    organizationName: '[Prospective client organization name]',
    website: 'https://[prospect-domain].com',
    contactName: 'Gregory S. Almeida',
    corporateEmail: 'employer.pending@velnoris.demo',
    industry: 'Consumer and Retail',
    headquartersLocation: 'Minneapolis, MN',
    organizationType: 'public',
    verificationStatus: 'pending_administrator_verification',
    createdAt: '2026-08-30T14:52:00Z',
    updatedAt: '2026-08-31T08:05:00Z',
  },
];

export const recruiterProfiles: RecruiterProfile[] = [
  {
    id: 'rec-1',
    userId: 'user-rec-1',
    title: 'Partner, Healthcare and Industrial',
    practiceAreas: ['Healthcare and Health Technology', 'Manufacturing and Industrial', 'Aerospace and Defense'],
    regions: ['United States'],
    isMandateOwner: true,
    createdAt: '2026-01-08T08:00:00Z',
  },
  {
    id: 'rec-2',
    userId: 'user-rec-2',
    title: 'Partner, Technology and Board Practice',
    practiceAreas: ['Technology, Data and Artificial Intelligence', 'Cybersecurity', 'Financial Services'],
    regions: ['United States', 'EMEA'],
    isMandateOwner: true,
    createdAt: '2026-01-08T08:00:00Z',
  },
  {
    id: 'rec-3',
    userId: 'user-rec-3',
    title: 'Principal, Energy and Supply Chain',
    practiceAreas: ['Energy and Infrastructure', 'Supply Chain and Logistics', 'Life Sciences and Pharmaceuticals'],
    regions: ['United States'],
    isMandateOwner: true,
    createdAt: '2026-02-14T08:00:00Z',
  },
];

export const testAccounts = [
  { role: 'Candidate — complete profile', email: 'candidate@velnoris.demo', password: 'Executive#2026' },
  { role: 'Candidate — incomplete profile', email: 'candidate.new@velnoris.demo', password: 'Executive#2026' },
  { role: 'Employer — verified', email: 'employer@velnoris.demo', password: 'Employer#2026' },
  { role: 'Employer — pending verification', email: 'employer.pending@velnoris.demo', password: 'Employer#2026' },
  { role: 'Recruiter', email: 'recruiter@velnoris.demo', password: 'Consultant#2026' },
  { role: 'Administrator', email: 'admin@velnoris.demo', password: 'Administrator#2026' },
  { role: 'Super Administrator', email: 'superadmin@velnoris.demo', password: 'SuperAdmin#2026' },
];
